export const singleton = <T>(name: string, value: T | (() => T)): T => {
  const windowObj = window as any;
  windowObj.__singletons ??= {};
  windowObj.__singletons[name] ??= value;
  return windowObj.__singletons[name];
};
